module.exports = __webpack_public_path__ + "static/media/img_vms_006.eaa15e08.png";